exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app,.index,body,html{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}.index{background-color:#f5f5f5}.dashboard-container,.full-wrap{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}.dashboard-container{-ms-flex-direction:column;flex-direction:column}.app-start-loader-wrapper{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#fafafb;height:100vh;width:100vw}.app-start-loader{border:5px solid #f3f3f3;border-top:5px solid #4dba97;width:60px;height:60px;border-radius:50%;animation:spin .85s linear infinite;margin-top:40px;margin-bottom:40px}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/App.css
// module id = 853
// module chunks = 0